// The word for a captor's decision, as the sim recorded it.
//
// A royal and a hero have the same four answers — ransom, hold, execute,
// release — so they share one set of words. The two unions are kept apart in
// the sim, where they are different questions, but they read the same here.

import type { CaptureDecision } from '../../dynasty/dynasty.js';
import type { HeroCaptivityChoice } from '../../heroes/captivity.js';
import type { MessageKey } from '../../i18n/index.js';

export function decisionLabel(decision: CaptureDecision | HeroCaptivityChoice | null): MessageKey {
  switch (decision) {
    case 'ransom':
      return 'espionage.choiceRansom';
    case 'hold':
      return 'espionage.choiceHold';
    case 'execute':
      return 'espionage.choiceExecute';
    case 'release':
      return 'espionage.choiceRelease';
    default:
      return 'espionage.undecided';
  }
}
